import { css } from 'styled-components';

export default css`
  display: flex;
  flex-wrap: wrap;
`;
